const genAbsoluteUrl = (sourcePath, link) => `${sourcePath}/${link[0] === '/'
  ? link.substring(1)
  : link}`;

export default genAbsoluteUrl;
